// source: pbtypes/gen/scan_planner/scan_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var pbtypes_gen_scan_planner_component_request_pb = require('../../../pbtypes/gen/scan_planner/component_request_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_component_request_pb);
goog.exportSymbol('proto.scan_planner.ScanSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.ScanSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scan_planner.ScanSettings.repeatedFields_, null);
};
goog.inherits(proto.scan_planner.ScanSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.ScanSettings.displayName = 'proto.scan_planner.ScanSettings';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scan_planner.ScanSettings.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.ScanSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.ScanSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.ScanSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.ScanSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
componentSettingsList: jspb.Message.toObjectList(msg.getComponentSettingsList(),
    pbtypes_gen_scan_planner_component_request_pb.ComponentRequest.toObject, includeInstance),
stopForPhoto: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
scanDistanceForGsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
gsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
effectiveGsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
geofenceStrictCeiling: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
geofenceStrictFloor: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
geofenceStrictLateral: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
exteriorCaptureCeil: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
exteriorCaptureFloor: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
exteriorCaptureLateral: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
scanVolumeInside: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
scanVolumeExtendCaptureDistance: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
rollingShutterCorrection: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
globalMaximumSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
dtedMapPath: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.ScanSettings}
 */
proto.scan_planner.ScanSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.ScanSettings;
  return proto.scan_planner.ScanSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.ScanSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.ScanSettings}
 */
proto.scan_planner.ScanSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_scan_planner_component_request_pb.ComponentRequest;
      reader.readMessage(value,pbtypes_gen_scan_planner_component_request_pb.ComponentRequest.deserializeBinaryFromReader);
      msg.addComponentSettings(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStopForPhoto(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setScanDistanceForGsd(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGsd(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setEffectiveGsd(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGeofenceStrictCeiling(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGeofenceStrictFloor(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGeofenceStrictLateral(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExteriorCaptureCeil(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExteriorCaptureFloor(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExteriorCaptureLateral(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScanVolumeInside(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setScanVolumeExtendCaptureDistance(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRollingShutterCorrection(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGlobalMaximumSpeed(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setDtedMapPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.ScanSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.ScanSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.ScanSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.ScanSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComponentSettingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_scan_planner_component_request_pb.ComponentRequest.serializeBinaryToWriter
    );
  }
  f = message.getStopForPhoto();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getScanDistanceForGsd();
  if (f !== 0.0) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = message.getGsd();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getEffectiveGsd();
  if (f !== 0.0) {
    writer.writeFloat(
      18,
      f
    );
  }
  f = message.getGeofenceStrictCeiling();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getGeofenceStrictFloor();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getGeofenceStrictLateral();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getExteriorCaptureCeil();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getExteriorCaptureFloor();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getExteriorCaptureLateral();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getScanVolumeInside();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getScanVolumeExtendCaptureDistance();
  if (f !== 0.0) {
    writer.writeFloat(
      12,
      f
    );
  }
  f = message.getRollingShutterCorrection();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getGlobalMaximumSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      15,
      f
    );
  }
  f = message.getDtedMapPath();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * repeated ComponentRequest component_settings = 1;
 * @return {!Array<!proto.scan_planner.ComponentRequest>}
 */
proto.scan_planner.ScanSettings.prototype.getComponentSettingsList = function() {
  return /** @type{!Array<!proto.scan_planner.ComponentRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_scan_planner_component_request_pb.ComponentRequest, 1));
};


/**
 * @param {!Array<!proto.scan_planner.ComponentRequest>} value
 * @return {!proto.scan_planner.ScanSettings} returns this
*/
proto.scan_planner.ScanSettings.prototype.setComponentSettingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.scan_planner.ComponentRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scan_planner.ComponentRequest}
 */
proto.scan_planner.ScanSettings.prototype.addComponentSettings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.scan_planner.ComponentRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.clearComponentSettingsList = function() {
  return this.setComponentSettingsList([]);
};


/**
 * optional bool stop_for_photo = 3;
 * @return {boolean}
 */
proto.scan_planner.ScanSettings.prototype.getStopForPhoto = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setStopForPhoto = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional float scan_distance_for_gsd = 13;
 * @return {number}
 */
proto.scan_planner.ScanSettings.prototype.getScanDistanceForGsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setScanDistanceForGsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional float gsd = 4;
 * @return {number}
 */
proto.scan_planner.ScanSettings.prototype.getGsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setGsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float effective_gsd = 18;
 * @return {number}
 */
proto.scan_planner.ScanSettings.prototype.getEffectiveGsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setEffectiveGsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional bool geofence_strict_ceiling = 5;
 * @return {boolean}
 */
proto.scan_planner.ScanSettings.prototype.getGeofenceStrictCeiling = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setGeofenceStrictCeiling = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool geofence_strict_floor = 6;
 * @return {boolean}
 */
proto.scan_planner.ScanSettings.prototype.getGeofenceStrictFloor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setGeofenceStrictFloor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool geofence_strict_lateral = 7;
 * @return {boolean}
 */
proto.scan_planner.ScanSettings.prototype.getGeofenceStrictLateral = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setGeofenceStrictLateral = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool exterior_capture_ceil = 8;
 * @return {boolean}
 */
proto.scan_planner.ScanSettings.prototype.getExteriorCaptureCeil = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setExteriorCaptureCeil = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool exterior_capture_floor = 9;
 * @return {boolean}
 */
proto.scan_planner.ScanSettings.prototype.getExteriorCaptureFloor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setExteriorCaptureFloor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool exterior_capture_lateral = 10;
 * @return {boolean}
 */
proto.scan_planner.ScanSettings.prototype.getExteriorCaptureLateral = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setExteriorCaptureLateral = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool scan_volume_inside = 11;
 * @return {boolean}
 */
proto.scan_planner.ScanSettings.prototype.getScanVolumeInside = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setScanVolumeInside = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional float scan_volume_extend_capture_distance = 12;
 * @return {number}
 */
proto.scan_planner.ScanSettings.prototype.getScanVolumeExtendCaptureDistance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setScanVolumeExtendCaptureDistance = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional bool rolling_shutter_correction = 14;
 * @return {boolean}
 */
proto.scan_planner.ScanSettings.prototype.getRollingShutterCorrection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setRollingShutterCorrection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional float global_maximum_speed = 15;
 * @return {number}
 */
proto.scan_planner.ScanSettings.prototype.getGlobalMaximumSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setGlobalMaximumSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional string dted_map_path = 17;
 * @return {string}
 */
proto.scan_planner.ScanSettings.prototype.getDtedMapPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_planner.ScanSettings} returns this
 */
proto.scan_planner.ScanSettings.prototype.setDtedMapPath = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


goog.object.extend(exports, proto.scan_planner);
